enum LangType {
  zh = 'CN',
  en = 'EN',
  es = 'ES-MX'
}
export default LangType
